import { CFormSelect } from '@coreui/react';
import React from 'react';
import type { FilterOption } from './FilterSelect.types';

interface FilterSelectProps {
  id?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: FilterOption[];
  className?: string;
}

export const FilterSelect: React.FC<FilterSelectProps> = ({
  id,
  value,
  onChange,
  options,
  className = '',
}) => {
  return (
    <CFormSelect id={id} value={value} onChange={onChange} className={className}>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </CFormSelect>
  );
};
